export default __webpack_public_path__ + "static/media/iulius.7ce87a71.png";